angular
    .module('login',[
        'app',
        'ngCookies',
        'gettext',
        'restangular',
        'lodash',

        'aprima-core',
        'aprima-bridge',
        'aprima-config',
        'aprima-facility-api',
        'aprima-legacy-common',
        'aprima-provider-api',
        'aprima-patient-api'
    ]);